import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useCreateTeamAndAddToLeague } from "../api/LeagueApiProvider";
import { Loading } from "../nav/Loading";
import { TeamForm } from "../teams/TeamForm";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { safeReturnTo } from "../utils/safeReturnTo";
import { useNumericParams } from "../utils/useNumericParams";
export const CreateTeamForLeague = () => {
    const { id: leagueId } = useNumericParams();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const returnTo = searchParams.get("returnTo");
    const onSuccess = () => {
        navigate(safeReturnTo(returnTo, `/leagues/${leagueId}/`));
    };
    const onError = (error) => {
        setLoading(false);
        setError(error);
    };
    const mutation = useCreateTeamAndAddToLeague({
        leagueId,
        onMutate: () => setLoading(true),
        onSuccess,
        onError,
    });
    if (loading) {
        return _jsx(Loading, {});
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: !!error, message: "Failed to create team. Please try again.", onClose: () => setError(undefined) }), _jsx(Typography, { variant: "h4", gutterBottom: true, sx: { fontSize: { xs: "1.75rem", sm: "2.125rem" } }, children: "Create Team for League" }), _jsx(TeamForm, { onSubmit: mutation.mutate, defaultAddAsPlayer: false, defaultAddAsManager: false })] }));
};
